import { useTranslation } from 'react-i18next';

import useIsUiHidden from 'hooks/dom/useIsUiHidden';

import useNumberFormatter from '../../../../hooks/format/useNumberFormatter';
import ProfTable from '../../ProfTable';

const RevenueTable = ({ tableData }) => {
  const { t } = useTranslation();
  const isUiHidden = useIsUiHidden();
  const formatNumber = useNumberFormatter({ minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const currentYear = new Date().getFullYear();

  const transformFinancialDataToTable = data => {
    const incomeRow = { metric: 'Income' };
    const profitRow = { metric: 'Profit' };

    // Extract years and sort descending
    const sortedYears = [...data].map(item => new Date(item.date).getFullYear()).sort((a, b) => b - a);

    // Get the latest 5 years
    const latestFiveYears = sortedYears.slice(0, 5).sort((a, b) => a - b);

    // Filter the data for those 5 years only
    data
      .filter(item => latestFiveYears.includes(new Date(item.date).getFullYear()))
      .forEach(({ date, income, profit }) => {
        const year = new Date(date).getFullYear();
        incomeRow[year] = income;
        profitRow[year] = profit;
      });

    return [incomeRow, profitRow];
  };

  const modifiedData = transformFinancialDataToTable(tableData);

  const tableColumns = [
    {
      title: t('professionalReport.financialData.profitAndRevenue.table.metric.title'),
      dataIndex: 'metric',
      key: 'metric',
      fixed: 'left',
      render: text => t(`professionalReport.financialData.profitAndRevenue.table.metric.${text}`),
    },
    ...Object.keys(modifiedData[0])
      .filter(key => key !== 'metric')
      .filter(year => (!isUiHidden ? parseInt(year) >= currentYear - 8 : true))
      .map(year => ({
        title: year,
        dataIndex: year,
        key: year,
        render: value => (typeof value === 'number' ? formatNumber(value) : value),
      })),
  ];

  return (
    <ProfTable
      rowKey="metric"
      bordered
      dataSource={modifiedData}
      columns={tableColumns}
      scroll={isUiHidden ? false : { x: 'max-content' }}
      pagination={false}
    />
  );
};

export default RevenueTable;
